/* HouseNord base.js */
(function(){

  /* ── Announcement rotator ─────────────────────── */
  var bar = document.querySelector('[data-announcement-rotator]');
  if (bar) {
    var msgs = bar.querySelectorAll('[data-msg]');
    if (msgs.length > 1) {
      var idx = 0;
      setInterval(function(){
       msgs[idx].style.opacity = 0; msgs[idx].style.position = 'absolute'; msgs[idx].style.pointerEvents = 'none';
        idx = (idx + 1) % msgs.length;
        msgs[idx].style.opacity = 1; msgs[idx].style.position = 'static'; msgs[idx].style.pointerEvents = 'auto';
      }, 4500);
    }
  }

  /* ── Desktop dropdown nav ─────────────────────── */
  var navItems = document.querySelectorAll('.nav-item.has-dropdown');
  navItems.forEach(function(item){
    var btn = item.querySelector('.nav-item__btn');
    function open(){
      navItems.forEach(function(o){ if(o!==item){ o.classList.remove('is-open'); o.querySelector('.nav-item__btn').setAttribute('aria-expanded','false'); } });
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded','true');
    }
    function close(){
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded','false');
    }
    // Hover (desktop)
    var closeTimer;
    item.addEventListener('mouseenter', function(){ clearTimeout(closeTimer); open(); });
    item.addEventListener('mouseleave', function(){ closeTimer = setTimeout(close, 220); });
    // Click / keyboard
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      item.classList.contains('is-open') ? close() : open();
    });
  });
  document.addEventListener('click', function(e){
    // Only close mega menus if click is outside the nav
    if(!e.target.closest('.header__nav')){
      navItems.forEach(function(item){
        item.classList.remove('is-open');
        var btn = item.querySelector('.nav-item__btn');
        if(btn) btn.setAttribute('aria-expanded','false');
      });
    }
  });

  /* ── Mobile nav drawer ────────────────────────── */
  var drawer   = document.querySelector('[data-mobile-nav]');
  var backdrop = document.querySelector('.mobile-nav__backdrop');
  var openers  = document.querySelectorAll('[data-burger]');
  var closers  = document.querySelectorAll('[data-burger-close]');

  function openNav(){
    if(!drawer) return;
    drawer.classList.add('is-open'); backdrop.classList.add('is-open');
    drawer.removeAttribute('aria-hidden'); document.body.style.overflow='hidden';
  }
  function closeNav(){
    if(!drawer) return;
    drawer.classList.remove('is-open'); backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true'); document.body.style.overflow='';
  }
  openers.forEach(function(b){ b.addEventListener('click', openNav); });
  closers.forEach(function(e){ e.addEventListener('click', closeNav); });
  if(drawer){ drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeNav); }); }

  /* ── Mobile accordion submenus ────────────────── */
  document.querySelectorAll('[data-mobile-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var group    = btn.closest('[data-mobile-group]');
      // Support both class names
      var children = group.querySelector('.mobile-children') || group.querySelector('.mobile-nav__children');
      if(!children) return;
      var isOpen   = children.classList.contains('is-open');

      // Close all others
      document.querySelectorAll('.mobile-children.is-open, .mobile-nav__children.is-open').forEach(function(c){
        c.classList.remove('is-open'); c.setAttribute('aria-hidden','true');
        var t = c.closest('[data-mobile-group]');
        if(t){ var tb = t.querySelector('[data-mobile-toggle]'); if(tb) tb.setAttribute('aria-expanded','false'); }
      });

      if(!isOpen){
        children.classList.add('is-open'); children.removeAttribute('aria-hidden');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });

  /* ── AI Concierge ─────────────────────────────── */
  var launchers = document.querySelectorAll('[data-concierge-launcher]');
  var widget   = document.querySelector('[data-concierge]');
  var closeBtn = document.querySelector('[data-concierge-close]');
  var form     = document.querySelector('[data-concierge-form]');
  var input    = document.querySelector('[data-concierge-input]');
  var body     = document.querySelector('[data-concierge-body]');
  var history  = [];
  var PROXY    = form ? (form.dataset.proxy || '') : '';

  // Persist the conversation across page navigation (cleared when the tab closes)
  var STORAGE_KEY = 'hn_concierge_history';
  function saveHistory(){
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(history)); } catch(e){}
  }
  function loadHistory(){
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if(!raw) return;
      var saved = JSON.parse(raw);
      if(!Array.isArray(saved) || !saved.length) return;
      history = saved;
      saved.forEach(function(msg){
  var el = addMsg(msg.role, msg.content);
  if(msg.products && msg.products.length){ renderProductCards(el, msg.products); }
});
    } catch(e){}
  }
  function openC(){
    if(widget){
      widget.classList.add('is-open');
      launchers.forEach(function(el){ el.style.opacity='0'; el.style.pointerEvents='none'; el.style.visibility='hidden'; });
    }
  }
  function closeC(){
    if(widget){
      widget.classList.remove('is-open');
      launchers.forEach(function(el){ el.style.opacity=''; el.style.pointerEvents=''; el.style.visibility=''; });
    }
  }
  launchers.forEach(function(el){ el.addEventListener('click', openC); });
  if(closeBtn) closeBtn.addEventListener('click', closeC);

  function addMsg(role, text){
    var el = document.createElement('div');
    el.className = 'concierge__msg ' + role;
    el.innerHTML = '<div class="concierge__bubble"></div>';
    el.querySelector('.concierge__bubble').textContent = text;
    body.appendChild(el); body.scrollTop = body.scrollHeight;
      return el;
  }

  function renderProductCards(afterEl, products){
    if(!products || !products.length) return;
    var cards = document.createElement('div');
    cards.className = 'concierge__products';
    products.forEach(function(p){
      var card = document.createElement('a');
      card.href = p.url || '/collections/all';
      card.className = 'concierge__product-card';
      card.innerHTML =
        (p.image
          ? '<div class="concierge__product-img"><img src="'+p.image+'" alt="'+(p.alt||p.title)+'" loading="lazy"></div>'
          : '<div class="concierge__product-img concierge__product-img--empty"><span>HN</span></div>'
        )+
        '<div class="concierge__product-info">'+
          '<div class="concierge__product-name">'+p.title+'</div>'+
          (p.desc ? '<div class="concierge__product-desc">'+p.desc+'</div>' : '')+
          '<div class="concierge__product-footer">'+
            '<span class="concierge__product-price">'+(p.price||'')+'</span>'+
            '<span class="concierge__product-cta">View piece →</span>'+
          '</div>'+
        '</div>';
      cards.appendChild(card);
    });
    afterEl.parentNode.insertBefore(cards, afterEl.nextSibling);
  }

  loadHistory();

  if(form){
    form.addEventListener('submit', async function(e){
      e.preventDefault();
      var text = (input.value||'').trim(); if(!text) return;
      input.value = ''; input.disabled = true;
     addMsg('user', text); history.push({role:'user', content:text}); saveHistory();
      var typing = addMsg('assistant','…');

      if(!PROXY){
        typing.querySelector('.concierge__bubble').textContent =
          'The Concierge is almost ready — please paste your Worker URL in Theme Settings → AI Concierge.';
        input.disabled = false; return;
      }

      try {
        var res = await fetch(PROXY, {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({messages: history})
        });
        if(!res.ok) throw new Error('HTTP '+res.status);
        var data = await res.json();
        var rawReply = data.reply || 'Forgive me — the line dropped. Would you mind repeating that?';
        var products = data.products || [];
        // Strip markdown * and ** from AI replies
        var reply = rawReply.replace(/\*\*([^*]+)\*\*/g,'$1').replace(/\*([^*]+)\*/g,'$1').replace(/\*/g,'');
            history.push({role:'assistant', content:reply, products:products});
        saveHistory();
        typing.querySelector('.concierge__bubble').textContent = reply;

        // Render product cards with images
        renderProductCards(typing, products);

        body.scrollTop = body.scrollHeight;
      } catch(err){
        typing.querySelector('.concierge__bubble').textContent =
          'Forgive me — the line dropped. Would you mind repeating that?';
      }
      input.disabled = false; input.focus();
    });
  }

})();

// ── Desktop mega dropdown nav ────────────────────
(function(){
  var items = document.querySelectorAll('.nav-item.has-dropdown');

  // Position all mega dropdowns correctly below the nav row
  function positionMega(){
    var navRow = document.querySelector('.header__nav-row');
    if(!navRow) return;
    var rect = navRow.getBoundingClientRect();
    var topPx = rect.bottom + window.scrollY;
    document.querySelectorAll('.mega-dropdown').forEach(function(m){
      m.style.top = topPx + 'px';
    });
  }
  positionMega();
  window.addEventListener('scroll', positionMega);
  window.addEventListener('resize', positionMega);

  items.forEach(function(item){
    var btn = item.querySelector('.nav-item__btn');
    var timer;
    function open(){
      clearTimeout(timer);
      positionMega();
      items.forEach(function(o){ if(o!==item){ o.classList.remove('is-open'); var b=o.querySelector('.nav-item__btn'); if(b)b.setAttribute('aria-expanded','false'); } });
      item.classList.add('is-open');
      if(btn) btn.setAttribute('aria-expanded','true');
    }
    function close(){ timer=setTimeout(function(){ item.classList.remove('is-open'); if(btn)btn.setAttribute('aria-expanded','false'); },250); }
    item.addEventListener('mouseenter',open);
    item.addEventListener('mouseleave',close);
    var mega = item.querySelector('.mega-dropdown');
    if(mega){
      mega.addEventListener('mouseenter',function(){ clearTimeout(timer); });
      mega.addEventListener('mouseleave',close);
    }
    if(btn) btn.addEventListener('click',function(e){ e.stopPropagation(); item.classList.contains('is-open')?close():open(); });
  });
  document.addEventListener('click',function(e){ if(!e.target.closest('.header__nav')){ items.forEach(function(i){ i.classList.remove('is-open'); var b=i.querySelector('.nav-item__btn'); if(b)b.setAttribute('aria-expanded','false'); }); } });
})();

// ── Mobile nav drawer ────────────────────────────
(function(){
  var drawer   = document.querySelector('[data-mobile-nav]');
  var backdrop = document.querySelector('.mobile-nav__backdrop');
  function openNav(){
    if(!drawer) return;
    drawer.classList.add('is-open'); backdrop.classList.add('is-open');
    drawer.removeAttribute('aria-hidden'); document.body.style.overflow='hidden';
  }
  function closeNav(){
    if(!drawer) return;
    drawer.classList.remove('is-open'); backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true'); document.body.style.overflow='';
  }
  document.querySelectorAll('[data-burger]').forEach(function(b){ b.addEventListener('click',openNav); });
  document.querySelectorAll('[data-burger-close]').forEach(function(b){ b.addEventListener('click',closeNav); });
  if(drawer){
    drawer.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        closeNav();
        // Navigation happens via href naturally
      });
    });
  }
})();

// ── Mobile accordion ─────────────────────────────
(function(){
  document.querySelectorAll('[data-mobile-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var group    = btn.closest('[data-mobile-group]');
      if(!group) return;
      var children = group.querySelector('.mob-children');
      if(!children) return;
      var isOpen   = children.classList.contains('is-open');
      // Close all
      document.querySelectorAll('.mob-children.is-open').forEach(function(c){
        c.classList.remove('is-open'); c.setAttribute('aria-hidden','true');
        var g=c.closest('[data-mobile-group]'); if(g){ var t=g.querySelector('[data-mobile-toggle]'); if(t)t.setAttribute('aria-expanded','false'); }
      });
      if(!isOpen){
        children.classList.add('is-open'); children.removeAttribute('aria-hidden');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });
})();

// ── Desktop 3-level dropdown toggles ─────────────
(function(){
  document.querySelectorAll('[data-dd-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var sub = btn.nextElementSibling;
      var isOpen = sub.classList.contains('is-open');
      // Close all others in same dropdown
      var parent = btn.closest('.nav-dropdown');
      if(parent){
        parent.querySelectorAll('.nav-dropdown__sub.is-open').forEach(function(s){
          s.classList.remove('is-open');
          var t = s.previousElementSibling;
          if(t) t.setAttribute('aria-expanded','false');
        });
      }
      if(!isOpen){
        sub.classList.add('is-open');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });
})();

// ── Mobile 3-level sub-accordion ─────────────────
(function(){
  document.querySelectorAll('[data-mob-subtoggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var group = btn.closest('[data-mob-subgroup]');
      var children = group ? group.querySelector('.mob-subchildren') : null;
      if(!children) return;
      var isOpen = children.classList.contains('is-open');
      // Close siblings
      var parent = btn.closest('.mob-children');
      if(parent){
        parent.querySelectorAll('.mob-subchildren.is-open').forEach(function(c){
          c.classList.remove('is-open'); c.setAttribute('aria-hidden','true');
          var t = c.previousElementSibling; if(t) t.setAttribute('aria-expanded','false');
        });
      }
      if(!isOpen){
        children.classList.add('is-open'); children.removeAttribute('aria-hidden');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });
})();

// ── Currency picker (CAD/USD) ────────────────────
(function(){
  var btn  = document.querySelector('[data-currency-btn]');
  var drop = document.querySelector('[data-currency-drop]');

  if(btn && drop){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      drop.classList.toggle('is-open');
      drop.setAttribute('aria-hidden', drop.classList.contains('is-open') ? 'false' : 'true');
    });
    document.addEventListener('click', function(){
      if(drop){ drop.classList.remove('is-open'); drop.setAttribute('aria-hidden','true'); }
    });
    drop.addEventListener('click', function(e){ e.stopPropagation(); });
  }

  // Auto-detect country on first visit and redirect if needed
  var saved = localStorage.getItem('hn_country');
  if(!saved){
    fetch('https://ipapi.co/json/')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var code = d.country_code;
        if(code === 'CA' || code === 'US'){
          localStorage.setItem('hn_country', code);
          // Submit the localization form for the detected country
          var form = document.querySelector('#currency-form');
          if(form){
            var inp = document.createElement('input');
            inp.type = 'hidden'; inp.name = 'country_code'; inp.value = code;
            // Only redirect if currently on wrong currency
            var currentCode = document.querySelector('[data-currency-code]');
            if(currentCode && !currentCode.textContent.trim().includes(code === 'CA' ? 'CAD' : 'USD')){
              form.appendChild(inp); form.submit();
            }
          }
        }
      }).catch(function(){});
  }
})();

// ── Discount code in cart ────────────────────────
(function(){
  var promoInput   = document.getElementById('cart-discount-input');
  var promoBtn     = document.getElementById('cart-discount-btn');
  var promoMsg     = document.getElementById('cart-discount-msg');
  var checkoutBtn  = document.getElementById('cart-checkout-btn');

  if(!promoBtn || !promoInput) return;

  var appliedCode = '';

  promoBtn.addEventListener('click', async function(){
    var code = promoInput.value.trim().toUpperCase();
    if(!code){
      promoMsg.style.color = 'red';
      promoMsg.textContent = 'Please enter a promo code.';
      return;
    }

    promoBtn.textContent = '...';
    promoBtn.disabled = true;

    try {
      // Shopify applies discounts at checkout via URL parameter
      // We redirect to checkout with the discount code pre-applied
      appliedCode = code;
      localStorage.setItem('hn_discount', code);

      promoMsg.style.color = '#5A8F5A';
      promoMsg.textContent = '✓ Code "' + code + '" saved — will apply at checkout.';
      promoInput.value = '';

      // Update checkout button click to go to /checkout?discount=CODE
      if(checkoutBtn){
        checkoutBtn.addEventListener('click', function(e){
          e.preventDefault();
          window.location.href = '/checkout?discount=' + encodeURIComponent(appliedCode);
        }, { once: true });
      }
    } catch(e){
      promoMsg.style.color = 'red';
      promoMsg.textContent = 'Something went wrong. Please enter your code at checkout.';
    }

    promoBtn.textContent = 'Apply';
    promoBtn.disabled = false;
  });

  // Restore saved discount if any
  var saved = localStorage.getItem('hn_discount');
  if(saved && promoMsg){
    promoMsg.style.color = '#5A8F5A';
    promoMsg.textContent = '✓ Code "' + saved + '" saved — will apply at checkout.';
    if(checkoutBtn){
      checkoutBtn.addEventListener('click', function(e){
        e.preventDefault();
        window.location.href = '/checkout?discount=' + encodeURIComponent(saved);
      }, { once: true });
    }
  }

  // Allow Enter key
  if(promoInput){
    promoInput.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){ e.preventDefault(); promoBtn.click(); }
    });
  }
})();

// ── Mobile currency switcher ──────────────────
(function(){
  var btn  = document.querySelector('[data-mob-currency-btn]');
  var drop = document.querySelector('[data-mob-currency-drop]');
  if(!btn || !drop) return;
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    drop.classList.toggle('is-open');
    drop.setAttribute('aria-hidden', drop.classList.contains('is-open') ? 'false' : 'true');
  });
  document.addEventListener('click', function(){
    drop.classList.remove('is-open');
    drop.setAttribute('aria-hidden','true');
  });
  drop.addEventListener('click', function(e){ e.stopPropagation(); });
})();

// ── Mobile header currency flag ───────────────
(function(){
  var btn  = document.querySelector('[data-mob-header-currency-btn]');
  var drop = document.querySelector('[data-mob-header-currency-drop]');
  if(!btn || !drop) return;
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    drop.classList.toggle('is-open');
    drop.setAttribute('aria-hidden', drop.classList.contains('is-open') ? 'false' : 'true');
  });
  document.addEventListener('click', function(){
    drop.classList.remove('is-open');
    drop.setAttribute('aria-hidden','true');
  });
  drop.addEventListener('click', function(e){ e.stopPropagation(); });
})();

/* ============================================================
   TRADE PROGRAM JS
   ============================================================ */
(function(){
  // ── Multi-step form ──────────────────────────────────────
  var form = document.getElementById('tp-application-form');
  if(!form) return;

  var currentStep = 1;
  var totalSteps = 4;

  function showStep(n){
    document.querySelectorAll('.tp-step').forEach(function(s){ s.classList.remove('active'); });
    var target = document.querySelector('.tp-step[data-step="'+n+'"]');
    if(target) target.classList.add('active');

    // Progress bar
    var fill = document.getElementById('tp-progress-fill');
    if(fill) fill.style.width = (n / totalSteps * 100) + '%';

    // Progress dots
    document.querySelectorAll('.tp-progress__step').forEach(function(dot){
      var s = parseInt(dot.dataset.step);
      dot.classList.remove('active','done');
      if(s === n) dot.classList.add('active');
      if(s < n) dot.classList.add('done');
    });

    currentStep = n;
    window.scrollTo({ top: document.getElementById('tp-apply').offsetTop - 80, behavior: 'smooth' });
  }

  // Next buttons
  form.querySelectorAll('.tp-next').forEach(function(btn){
    btn.addEventListener('click', function(){
      var step = btn.closest('.tp-step');
      var inputs = step.querySelectorAll('input[required], select[required]');
      var valid = true;
      inputs.forEach(function(inp){
        if(!inp.value.trim()){ inp.style.borderColor='#c00'; valid=false; }
        else inp.style.borderColor='';
      });
      if(valid) showStep(currentStep + 1);
    });
  });

  // Back buttons
  form.querySelectorAll('.tp-back').forEach(function(btn){
    btn.addEventListener('click', function(){ showStep(currentStep - 1); });
  });

  // Submit — generate reference number BEFORE capturing form data, then
  // send via Shopify's contact form and show the confirmation modal.
  form.addEventListener('submit', function(e){
    e.preventDefault();

    var step = form.querySelector('.tp-step.active');
    var required = step ? step.querySelectorAll('input[required], select[required]') : [];
    var valid = true;
    required.forEach(function(inp){
      if(!inp.value || !inp.value.trim()){ inp.style.borderColor = '#c00'; valid = false; }
      else inp.style.borderColor = '';
    });
    if(!valid) return;

    var g = function(sel){ return ((form.querySelector(sel)||{}).value||'').trim(); };
    var gChecked = function(sel){ var el = form.querySelector(sel+':checked'); return el ? el.value : ''; };
    var gAllChecked = function(sel){
      var els = form.querySelectorAll(sel+':checked');
      var vals = [];
      els.forEach(function(el){ vals.push(el.value); });
      return vals;
    };

    var email    = g('input[name="contact[email]"]');
    var fn       = g('input[name="contact[first_name]"]');
    var ln       = g('input[name="contact[last_name]"]');
    var biz      = g('input[name="contact[business_name]"]');
    var bizType  = g('select[name="contact[business_type]"]');
    var phone    = g('input[name="contact[phone]"]');
    var position = g('input[name="contact[position]"]');
    var address  = g('input[name="contact[address]"]');
    var city     = g('input[name="contact[city]"]');
    var province = g('input[name="contact[province]"]');
    var country  = g('input[name="contact[country]"]');
    var postal   = g('input[name="contact[postal_code]"]');
    var portfolio = g('input[name="contact[portfolio_url]"]');
    var instagram = g('input[name="contact[instagram]"]');
    var linkedin  = g('input[name="contact[linkedin]"]');
    var notes    = g('textarea[name="contact[notes]"]');
    var budget   = gChecked('input[name="contact[budget]"]');
    var perYear  = g('select[name="contact[projects_per_year]"]');
    var projTypes = gAllChecked('input[name="contact[project_types][]"]');

    var ref   = 'TP-' + String(Math.floor(100000 + Math.random() * 900000));
    var date  = new Date().toLocaleDateString('en-CA',{year:'numeric',month:'long',day:'numeric'});

    var bf = document.getElementById('tp-body-field');
    var rf = document.getElementById('tp-ref-field');
    if(rf) rf.value = ref;
    if(bf) bf.value = '=== TRADE APPLICATION — HOUSENORD ===\nReference: '+ref+'\nDate: '+date+'\nApplicant: '+fn+' '+ln+'\nEmail: '+email+'\nPhone: '+phone+'\nCompany: '+biz+'\n\nReply to this email to contact the applicant directly.';

    var submitBtn = form.querySelector('.tp-submit');
    var originalText = submitBtn ? submitBtn.textContent : null;
    if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

    // Build FormData AFTER the fields above are populated, so the
    // reference number and formatted body actually get submitted.
    var data = new FormData(form);

    // Best-effort backup via Shopify's native contact form. Not relied on —
    // both the applicant confirmation AND the internal store notification
    // are sent through the Worker below, which we can actually verify
    // delivery for. This call just runs alongside it in case it's useful.
    fetch('/contact', { method:'POST', body: data }).catch(function(){});

    function showError(msg){
      if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = originalText; }
      var errEl = form.querySelector('.tp-submit-error');
      if(!errEl){
        errEl = document.createElement('p');
        errEl.className = 'tp-submit-error';
        errEl.style.cssText = 'color:#c0392b;font-size:13px;margin-top:12px;text-align:center';
        form.appendChild(errEl);
      }
      errEl.textContent = msg;
    }

    function showSuccess(){
      if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = originalText; }
      var modal = document.getElementById('tp-success-modal');
      var refEl = document.getElementById('tp-success-ref-num');
      if(refEl) refEl.textContent = ref;
      if(modal){
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden','false');
        document.body.classList.add('tp-modal-open');
      }
    }

    if(!window.HN_TRADE_EMAIL_WORKER_URL){
      showError('Application system is not fully configured yet — please email info@housenord.com directly.');
      return;
    }

    fetch(window.HN_TRADE_EMAIL_WORKER_URL + '/send-confirmation', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email, name: (fn+' '+ln).trim(), ref: ref, date: date,
        businessName: biz, businessType: bizType, phone: phone, position: position,
        address: address, city: city, province: province, country: country, postalCode: postal,
        budget: budget, projectsPerYear: perYear, projectTypes: projTypes, notes: notes,
        portfolioUrl: portfolio, instagram: instagram, linkedin: linkedin
      })
    })
      .then(function(r){ return r.json().then(function(d){ return { ok:r.ok, data:d }; }); })
      .then(function(result){
        if(result.ok){ showSuccess(); }
        else { showError('Could not submit your application — please try again or email info@housenord.com directly.'); }
      })
      .catch(function(){
        showError('Could not submit your application — check your connection and try again.');
      });
  });

  // Success modal close (X, overlay click, or Escape)
  document.querySelectorAll('[data-tp-success-close]').forEach(function(el){
    el.addEventListener('click', function(){
      var modal = document.getElementById('tp-success-modal');
      if(modal){
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden','true');
        document.body.classList.remove('tp-modal-open');
      }
    });
  });
  document.addEventListener('keydown', function(e){
    var modal = document.getElementById('tp-success-modal');
    if(e.key === 'Escape' && modal && modal.classList.contains('is-open')){
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('tp-modal-open');
    }
  });

  // FAQ accordion
  document.querySelectorAll('.tp-faq__q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.tp-faq__item');
      var answer = item.querySelector('.tp-faq__a');
      var isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.tp-faq__item.open').forEach(function(i){
        i.classList.remove('open');
        i.querySelector('.tp-faq__a').style.maxHeight = '0';
      });
      if(!isOpen){
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // Smooth scroll for #tp-apply links
  document.querySelectorAll('.tp-scroll').forEach(function(a){
    a.addEventListener('click', function(e){
      var target = document.querySelector(a.getAttribute('href'));
      if(target){ e.preventDefault(); target.scrollIntoView({ behavior:'smooth', block:'start' }); }
    });
  });

  // File upload
  function setupUpload(zoneId, inputId, listId){
    var zone = document.getElementById(zoneId);
    var input = document.getElementById(inputId);
    var list = document.getElementById(listId);
    if(!zone || !input || !list) return;

    zone.addEventListener('dragover', function(e){ e.preventDefault(); zone.classList.add('drag-over'); });
    zone.addEventListener('dragleave', function(){ zone.classList.remove('drag-over'); });
    zone.addEventListener('drop', function(e){
      e.preventDefault(); zone.classList.remove('drag-over');
      renderFiles(e.dataTransfer.files);
    });
    input.addEventListener('change', function(){ renderFiles(input.files); });

    function renderFiles(files){
      list.innerHTML = '';
      Array.from(files).forEach(function(f){
        var div = document.createElement('div');
        div.className = 'tp-file-item';
        div.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/></svg>' + f.name;
        list.appendChild(div);
      });
    }
  }
  setupUpload('tp-upload-zone','tp-file-input','tp-file-list');

  // Fade-in on scroll
  var fadeEls = document.querySelectorAll('[data-tp-fade]');
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.style.opacity=1; e.target.style.transform='translateY(0)'; } });
    },{ threshold:.1 });
    fadeEls.forEach(function(el){
      el.style.opacity='0'; el.style.transform='translateY(20px)'; el.style.transition='opacity .5s ease, transform .5s ease';
      obs.observe(el);
    });
  }
})();

/* ============================================================
   TRADE DASHBOARD JS
   ============================================================ */
(function(){
  // Tab navigation
  var navItems = document.querySelectorAll('[data-td-nav]');
  if(!navItems.length) return;

  navItems.forEach(function(item){
    item.addEventListener('click', function(){
      var target = item.dataset.tdNav;
      navItems.forEach(function(i){ i.classList.remove('active'); });
      item.classList.add('active');
      document.querySelectorAll('.td-panel').forEach(function(p){ p.classList.remove('active'); });
      var panel = document.getElementById('td-' + target);
      if(panel) panel.classList.add('active');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // Projects (localStorage)
  var PROJECTS_KEY = 'hn_trade_projects';
  var projectsListEl = document.getElementById('td-projects-list');
  var newBtn = document.getElementById('td-new-project-btn');
  var newForm = document.getElementById('td-new-project-form');
  var nameInput = document.getElementById('td-project-name-input');
  var createBtn = document.getElementById('td-create-project-btn');
  var cancelBtn = document.getElementById('td-cancel-project-btn');

  function getProjects(){ try{ return JSON.parse(localStorage.getItem(PROJECTS_KEY))||[]; }catch(e){ return []; } }
  function saveProjects(p){ localStorage.setItem(PROJECTS_KEY, JSON.stringify(p)); }

  function renderProjects(){
    if(!projectsListEl) return;
    var projects = getProjects();
    if(!projects.length){ projectsListEl.innerHTML='<div class="td-empty"><p>No projects yet. Create your first project to start saving products.</p></div>'; return; }
    projectsListEl.innerHTML = projects.map(function(p){
      return '<div class="td-project-card"><p class="td-project-card__name">'+p.name+'</p><p class="td-project-card__count">'+( p.products ? p.products.length : 0 )+' saved items</p></div>';
    }).join('');
  }

  if(newBtn) newBtn.addEventListener('click', function(){ newForm.style.display='flex'; newBtn.style.display='none'; });
  if(cancelBtn) cancelBtn.addEventListener('click', function(){ newForm.style.display='none'; newBtn.style.display='block'; });
  if(createBtn) createBtn.addEventListener('click', function(){
    var name = nameInput ? nameInput.value.trim() : '';
    if(!name) return;
    var projects = getProjects();
    projects.push({ id: Date.now(), name: name, products: [] });
    saveProjects(projects);
    renderProjects();
    if(newForm) newForm.style.display='none';
    if(newBtn) newBtn.style.display='block';
    if(nameInput) nameInput.value='';
  });
  renderProjects();

  // Save profile (visual feedback only — real save needs Shopify customer account API)
  var saveProfileBtn = document.getElementById('td-save-profile-btn');
  var savedMsg = document.getElementById('td-profile-saved');
  if(saveProfileBtn && savedMsg){
    saveProfileBtn.addEventListener('click', function(){
      savedMsg.style.display='block';
      setTimeout(function(){ savedMsg.style.display='none'; }, 3000);
    });
  }

  // Dashboard doc upload
  var tdZone = document.getElementById('td-upload-zone');
  var tdInput = document.getElementById('td-doc-input');
  var tdList = document.getElementById('td-doc-list');
  if(tdZone && tdInput && tdList){
    tdZone.addEventListener('dragover', function(e){ e.preventDefault(); tdZone.classList.add('drag-over'); });
    tdZone.addEventListener('dragleave', function(){ tdZone.classList.remove('drag-over'); });
    tdZone.addEventListener('drop', function(e){
      e.preventDefault(); tdZone.classList.remove('drag-over');
      renderDocs(e.dataTransfer.files);
    });
    tdInput.addEventListener('change', function(){ renderDocs(tdInput.files); });
    function renderDocs(files){
      Array.from(files).forEach(function(f){
        var div = document.createElement('div');
        div.className = 'tp-file-item';
        div.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/></svg>' + f.name;
        tdList.appendChild(div);
      });
    }
  }
})();

/* ── Newsletter Popup ── */
(function(){
  var overlay = document.getElementById('np-overlay');
  if(!overlay) return;
  var closeBtn = document.getElementById('np-close');
  var skipBtn  = document.getElementById('np-skip');
  var form     = document.getElementById('np-form');
  var errorEl  = document.getElementById('np-error');
  var delay      = parseInt(overlay.dataset.delay||'3',10)*1000;
  var daysHidden = parseInt(overlay.dataset.days||'30',10);
  var KEY = 'hn_popup_hidden_until';
  function shouldShow(){
    var path = window.location.pathname;
    if(path.indexOf('newsletter-confirmed') !== -1) return false;
    if(path.indexOf('trade-application-received') !== -1) return false;
    if(path.indexOf('trade-dashboard') !== -1) return false;
    if(path.indexOf('account') !== -1) return false;
    try{ var u=localStorage.getItem(KEY); return !u||Date.now()>parseInt(u,10); }catch(e){ return true; }
  }
  function hideForDays(){ try{ localStorage.setItem(KEY,String(Date.now()+daysHidden*864e5)); }catch(e){} }
  function openP(){ overlay.classList.add('active'); document.body.style.overflow='hidden'; }
  function closeP(){ overlay.classList.remove('active'); document.body.style.overflow=''; hideForDays(); }
  if(shouldShow()) setTimeout(openP, delay);
  if(closeBtn) closeBtn.addEventListener('click', closeP);
  if(skipBtn)  skipBtn.addEventListener('click', closeP);
  overlay.addEventListener('click', function(e){ if(e.target===overlay) closeP(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeP(); });
  if(form){
    form.addEventListener('submit', function(e){
      var emailEl  = document.getElementById('np-email');
      var bf       = document.getElementById('np-body-field');
      var returnTo = form.querySelector('input[name="return_to"]');
      var email    = emailEl ? emailEl.value.trim() : '';
      if(!email||email.indexOf('@')===-1){ e.preventDefault(); if(errorEl) errorEl.style.display='block'; return; }
      if(errorEl) errorEl.style.display='none';
      var conf = 'NL-' + String(Math.floor(100000 + Math.random() * 900000));
      try{
        sessionStorage.setItem('hn_newsletter_email', email);
        sessionStorage.setItem('hn_newsletter_conf', conf);
      }catch(x){}
      if(returnTo) returnTo.value = '/';
      if(bf) bf.value = '=== NEW NEWSLETTER SUBSCRIBER ===\nConfirmation: '+conf+'\nEmail: '+email+'\nDate: '+new Date().toLocaleDateString('en-CA')+'\nWelcome Code: WELCOME10';
      hideForDays();

      // Send the customer their own WELCOME10 email. The form below still
      // does a normal native submit (no preventDefault), so this request
      // needs `keepalive: true` to guarantee it's actually sent before the
      // browser navigates away to the confirmation page.
      if (window.HN_TRADE_EMAIL_WORKER_URL) {
        fetch(window.HN_TRADE_EMAIL_WORKER_URL + '/send-newsletter-welcome', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, confirmationNumber: conf }),
          keepalive: true
        }).catch(function(){});
      }
    });
  }
})();

/* ── Account Dropdown ── */
(function(){
  var btn  = document.querySelector('.hdr-account-btn');
  var drop = document.querySelector('.hdr-account-drop');
  var wrap = document.querySelector('.hdr-account-wrap');
  if(!btn||!drop||!wrap) return;

  // Toggle dropdown open/close
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    drop.classList.toggle('open');
  });

  // Close on outside click - but NOT when clicking links inside
  document.addEventListener('click', function(e){
    if(!wrap.contains(e.target)){
      drop.classList.remove('open');
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape') drop.classList.remove('open');
  });

  // Links inside dropdown: let href navigate normally
  // Use mousedown instead of click so navigation fires reliably
  drop.addEventListener('mousedown', function(e){
    var link = e.target.closest('a');
    if(link && link.href){
      // Close dropdown then navigate
      drop.classList.remove('open');
      // Small delay ensures the close animation doesn't block navigation
      e.preventDefault();
      setTimeout(function(){ window.location.href = link.href; }, 50);
    }
  });
})();
